module.exports = __webpack_public_path__ + "media/g4.ce931899.mp3";